// extracted by mini-css-extract-plugin
export default {"privacy-policy-container":"PrivacyPolicy_privacy-policy-container__+mbOp","privacy-policy-details":"PrivacyPolicy_privacy-policy-details__d0DQX"};